import React from "react";
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from "@material-ui/core";
import _ from "lodash";

import { useRouteMatch } from "react-router-dom";
import DialogCommonDefault from "../../../../../../components/dialogs/DialogCommonDefault";
import {
  ERROR_MESSAGE_UNEXPECTED_ERROR,
  SUCCESSFULLY_CREATED,
} from "../../../../../../utils/consts";
import ColorSelection from "../../../../../PrestoExpressEatprestoApp/pages/ThemeCustomizationPage/ColorSelection";
import ButtonCommon from "../../../../../../components/buttons/ButtonCommon";
import TextfieldDefaultNew from "../../../../../../components/textField/TextfieldDefaultNew";
import { createWrapper } from "../../../../../../services/menuApp/menuService";

export interface DirectoryAddModalProps {
  isOpen: any;
  setIsOpen: any;
  setDirectoryName: any;
  directoryName: any;
  isDirectoryNameEmpty: any;
  setIsDepartmentEmpty: any;
  handleCloseDirectoryAddModal: any;
  setUrl: any;
  isLoadingButton: any;
  url: any;
  setIsLoadingButton: any;
  categoryId: any;
  directoryId: any;
  directoryLevel: any;
  setSuccess: any;
  setError: any;
  setIsDirectoryNameEmpty: any;
  menuNodeList: any;
  wrapperId: any;
  menuId: any;
  firstWrapperId: any;
  setMenuNodeList: any;
  isRoot: any;
  setIsOpenDirectoryOrProductSelectionModal: any;
  color: any;
  setColor: any;
  onItemAdded?: (newItem?: any) => void;
}

const DirectoryAddModal: React.FunctionComponent<DirectoryAddModalProps> = ({
  isOpen,
  setIsOpen,
  setDirectoryName,
  directoryName,
  isDirectoryNameEmpty,
  setIsDepartmentEmpty,
  handleCloseDirectoryAddModal,
  setUrl,
  isLoadingButton,
  url,
  setIsLoadingButton,
  categoryId,
  directoryId,
  directoryLevel,
  setSuccess,
  setError,
  setIsDirectoryNameEmpty,
  menuNodeList,
  wrapperId,
  menuId,
  firstWrapperId,
  setMenuNodeList,
  isRoot,
  setIsOpenDirectoryOrProductSelectionModal,
  color,
  setColor,
  onItemAdded,
}) => {
  const match: any = useRouteMatch();

  // Helper function to extract ID from categoryId (handles both number and object)
  const getCategoryIdValue = (catId: any): number => {
    if (!catId) return 0;
    if (typeof catId === "number") return catId;
    if (typeof catId === "object" && catId.id) return catId.id;
    return 0;
  };

  // Function to recursively find and add directory to nested structure
  const findAndAddDirectory = (
    node: any,
    targetId: number,
    newDirectory: any,
  ): boolean => {
    if (!node) return false;

    // Check if current node is the target parent directory
    if (node.id === targetId) {
      if (!node.wrapper) {
        node.wrapper = {};
      }
      node.wrapper[newDirectory.id] = newDirectory;
      return true;
    }

    // Recursively search in wrapper children
    if (node.wrapper) {
      for (const key in node.wrapper) {
        if (findAndAddDirectory(node.wrapper[key], targetId, newDirectory)) {
          return true;
        }
      }
    }
    return false;
  };

  const handleDirectoryAddInfo = async () => {
    setIsLoadingButton(true);
    if (directoryName) {
      // Get the actual category ID value (handles both number and object)
      const actualCategoryId = getCategoryIdValue(categoryId);

      const body = {
        name: directoryName,
        locationId: match.params.locationId,
        categoryId: actualCategoryId,
        nameShort: "",
        directory: true,
        img: url,
        colour: color,
        directoryId: directoryId || "",
        directoryLevel: directoryLevel || 1,
      };
      try {
        const summaryString = `${directoryName} Directory is added`;

        const res = await createWrapper(
          match.params.locationId,
          body,
          "Menus Changed",
          summaryString,
          "menu",
        );

        // Get the newly created directory from response and normalize categoryId
        let newDirectory = res.data.data;
        if (
          newDirectory.categoryId &&
          typeof newDirectory.categoryId === "object"
        ) {
          newDirectory = {
            ...newDirectory,
            categoryId: newDirectory.categoryId.id,
          };
        }

        // Update local state directly with the response
        const cloneMenuNode = _.cloneDeep(menuNodeList);

        if (isRoot) {
          // Add at root level (under category)
          if (!cloneMenuNode[menuId]?.category[actualCategoryId]?.wrapper) {
            if (!cloneMenuNode[menuId]) cloneMenuNode[menuId] = {};
            if (!cloneMenuNode[menuId].category)
              cloneMenuNode[menuId].category = {};
            if (!cloneMenuNode[menuId].category[actualCategoryId])
              cloneMenuNode[menuId].category[actualCategoryId] = {};
            if (!cloneMenuNode[menuId].category[actualCategoryId].wrapper) {
              cloneMenuNode[menuId].category[actualCategoryId].wrapper = {};
            }
          }
          cloneMenuNode[menuId].category[actualCategoryId].wrapper[
            newDirectory.id
          ] = newDirectory;
        } else {
          // Add inside a nested directory
          let parentFound = false;

          // Search in categories
          if (cloneMenuNode[menuId]?.category) {
            for (const catKey in cloneMenuNode[menuId].category) {
              const category = cloneMenuNode[menuId].category[catKey];
              if (category.wrapper) {
                if (
                  findAndAddDirectory(category.wrapper, wrapperId, newDirectory)
                ) {
                  parentFound = true;
                  break;
                }
              }
            }
          }

          // Fallback: try using firstWrapperId
          if (
            !parentFound &&
            firstWrapperId &&
            cloneMenuNode[menuId]?.category[actualCategoryId]?.wrapper
          ) {
            const parentNode =
              cloneMenuNode[menuId].category[actualCategoryId].wrapper[
                firstWrapperId
              ];
            if (parentNode) {
              if (!parentNode.wrapper) {
                parentNode.wrapper = {};
              }
              parentNode.wrapper[newDirectory.id] = newDirectory;
              parentFound = true;
            }
          }
        }

        setMenuNodeList(cloneMenuNode);
        setIsDirectoryNameEmpty(false);
        setIsLoadingButton(false);
        setIsOpen(false);
        setIsOpenDirectoryOrProductSelectionModal(false);
        setSuccess(SUCCESSFULLY_CREATED);

        if (onItemAdded) {
          onItemAdded(newDirectory);
        }
      } catch (error) {
        setIsLoadingButton(false);
        setError(ERROR_MESSAGE_UNEXPECTED_ERROR);
      }
    } else {
      setIsLoadingButton(false);
      setIsDirectoryNameEmpty(true);
    }
  };

  return (
    <DialogCommonDefault
      open={isOpen}
      setOpen={setIsOpen}
      isNeedFixedHeight={false}
    >
      <DialogTitle>Add Directory</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography style={{ paddingLeft: "4px" }}>
              Directory Name
            </Typography>
            <TextfieldDefaultNew
              id="sign-password-input"
              name="sign-password-input"
              onChange={(e: any) => {
                setIsDepartmentEmpty(false);
                setDirectoryName(e.target.value);
              }}
              value={directoryName}
              type="text"
            />
            {isDirectoryNameEmpty && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "start",
                  marginBottom: "3px",
                }}
              >
                <Typography
                  align="left"
                  variant="caption"
                  style={{ color: "red" }}
                >
                  Please enter directory name.
                </Typography>
              </div>
            )}
          </Grid>
          <Grid item xs={12}>
            <Typography style={{ paddingLeft: "4px" }}>Image</Typography>
            <TextfieldDefaultNew
              id="sign-password-input"
              name="sign-password-input"
              onChange={(e: any) => {
                setUrl(e.target.value);
              }}
              value={url}
              type="text"
            />
          </Grid>

          <Grid item xs={12} style={{ marginTop: "4px" }}>
            <Typography style={{ paddingLeft: "4px" }}>Color</Typography>
            <ColorSelection
              title={"Color"}
              colorCode={color}
              setColor={(colorVal: any) => setColor(colorVal.hex)}
              setInitialData={() => setColor("")}
            />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions style={{ marginBottom: "8px" }}>
        <ButtonCommon
          variant="contained"
          style={{ fontSize: 11, width: "100px", marginRight: 8 }}
          color="yellow"
          onClick={handleCloseDirectoryAddModal}
        >
          Cancel
        </ButtonCommon>
        <ButtonCommon
          variant="contained"
          style={{
            fontSize: 11,
            marginLeft: 4,
            width: "100px",
          }}
          isLoadingPage={isLoadingButton}
          color={"orange"}
          onClick={handleDirectoryAddInfo}
        >
          {"Save"}
        </ButtonCommon>
      </DialogActions>
    </DialogCommonDefault>
  );
};

export default DirectoryAddModal;
